import { Box, CssBaseline, Toolbar } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { MainListItems } from '../../components/Navbar/listItems';
import NewNavbar from '../../components/Navbar/New/Navbar';
import Sidebar from '../../components/Navbar/Sidebar';
import theme from '../../mui-theme';
import FloatingButton from '../../components/elements/Floating-Button';
import { useNavigate, useParams } from 'react-router-dom';
import { getCurrentUserAssociation } from '../../modules/project';

const DashboardLayout = ({ children }) => {
  const isSmallScreen = window.innerWidth < 1025;

  const [open, setOpen] = useState(!isSmallScreen);  
  const drawerWidth = isSmallScreen ? 180 :240;

  const navigate = useNavigate();
  const { projectId } = useParams();

  const fetchCurrentUserData = async () => {
    try {
      await getCurrentUserAssociation(projectId);
    } catch (error) {
      navigate('/access-denied');
    }
  };

  useEffect(() => {
    if (projectId) {
      fetchCurrentUserData();
    }
  }, [projectId]);

  const toggleDrawer = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  return (
    <Box display="flex">
      <CssBaseline />
      <NewNavbar />
      <Sidebar
        theme={theme}
        MainListItems={MainListItems}
        open={open}
        toggleDrawer={toggleDrawer}
        type="dashboard"
        isSmallScreen={isSmallScreen}
        drawerWidth={drawerWidth}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
          padding: '16px',
          ml: open ? `${drawerWidth}px` : 7,
        }}>
        <Toolbar />
        <Box sx={{ flexGrow: 1, padding: '16px' }}>{children}</Box>
        <FloatingButton />
      </Box>
    </Box>
  );
};

export default DashboardLayout;
